import React from "react";
import ReactDOM from "react-dom";
import ProtectedRoot from "./App";
import { createBrowserRouter, RouterProvider, Route } from "react-router-dom";

// ribbon section imports
import SetProfile from "./components/sections/setProfile";
import SetWalletWrapped from "./components/sections/setWallet";
import SetTeam from "./components/sections/setTeam";
import SetPlan from "./components/sections/setPlan";
import Mint from "./components/sections/mint";
import Feed from "./components/sections/feed";
import Team from "./components/sections/team";
import PublicAward from "./components/sections/publicAward";

import { AuthProvider } from "./contexts/AuthContext";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AuthProvider>
        <ProtectedRoot />
      </AuthProvider>
    ),
    errorElement: <div>Error</div>,
    children: [
      {
        path: "",
        element: <Mint />,
      },
      {
        path: "set-profile",
        element: <SetProfile />,
      },
      {
        path: "set-wallet",
        element: <SetWalletWrapped />,
      },
      {
        path: "set-team",
        element: <SetTeam />,
      },
      {
        path: "set-plan",
        element: <SetPlan />,
      },
      {
        path: "feed",
        element: <Feed />,
      },
      {
        path: "mint",
        element: <Mint />,
      },
      {
        path: "team",
        element: <Team />,
      },
      {
        path: "support",
        element: <div>Email support@ribbon.cool</div>,
      },
      {
        path: "profile/:username",
        element: <div>Profile</div>,
      },
      {
        path: "p/:username",
        element: <div>Profile</div>,
      },
    ],
  },
  {
    path: "/award/:id",
    element: (
      <AuthProvider>
        <PublicAward />
      </AuthProvider>
    ),
  },
]);

ReactDOM.render(
  <RouterProvider router={router} />,
  document.getElementById("root")
);
